import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AlertColor } from '@mui/material';
import Login from "../Components/Login";
import { handleLogout } from '../Components/LogoutUtils';
import borgLogo from "../assets/img/Borg-logo.png";
import kepleraLogo from "../assets/img/Keplera-logo.png";
import Card from 'src/Components/Card';

const isKepleraVersion = process.env.REACT_APP_PRODUCT_NAME === "keplera";
const productWelcome = isKepleraVersion ? "Welcome to Keplera" : "Welcome to BORG";
const resetPasswordTitle = "Reset Password";
const productLogo = isKepleraVersion ? kepleraLogo : borgLogo;

type Props = { onNotification: (message: string, notificationType?: AlertColor) => void};

type LocationState = {
  fromResetPassword: boolean,
  success: boolean
};

const LoginPage = (props: Props) => {

  const navigate = useNavigate();
  const locationState = useLocation().state as LocationState;
  const [isResetMode, setIsResetMode] = useState(false);

  // Functions to switch between views
  const showResetPassword = () => navigate("/password-reset");

  // Dynamic title based on reset mode
  const currentTitle = isResetMode ? resetPasswordTitle : productWelcome;

  useEffect(() => {
    const loggedIn = localStorage.getItem("refresh-token");
    if (loggedIn) {
      // log user out if they go to the login page while already logged in
      handleLogout(navigate);
      props.onNotification("You've been logged out", "warning");
    }
  }, []);

  let successMessage;
  if (locationState && locationState.fromResetPassword && locationState.success) {
    successMessage = "Password reset successfully";
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Logo */}
      <div className="borg-logo" style={{ marginTop: '6vh' }}>
        <img alt="logo" src={productLogo} />
      </div>

      <Card title={currentTitle}>
        <Login 
          onNeedResetPassword={showResetPassword} 
          onResetModeChange={setIsResetMode}
        />
      </Card>
    </div>
  );
};

export default LoginPage;
